import { Modal, Pressable, StyleSheet, Text, View } from "react-native";
import React, { forwardRef } from "react";

export interface ActionPopupMenuRef {
  close: () => void;
}

type ActionItem = {
  title: string;
  onPress: () => void;
};

type Props = {
  visible: boolean;
  onClose: () => void;
  position: { top: number; left: number };
  actions: ActionItem[];
};

export const ActionPopupMenu = forwardRef<ActionPopupMenuRef, Props>(
  ({ visible, onClose, position, actions }: Props) => {
    return (
      <Modal
        visible={visible}
        transparent
        animationType={"none"}
        onRequestClose={onClose}
      >
        <Pressable
          onPress={onClose}
          className={"left-0 top-0 bottom-0 right-0 absolute"}
        >
          <View
            style={[
              styles.position,
              {
                top: position.top,
                left: position.left,
              },
            ]}
            className="w-[157px] h-[104px] bg-white rounded-md p-3 shadow-sm"
          >
            {actions.map((action, index) => (
              <Pressable
                key={index}
                onPress={() => {
                  action.onPress();
                  onClose();
                }}
              >
                <Text className="py-2.5">{action.title}</Text>
              </Pressable>
            ))}
          </View>
        </Pressable>
      </Modal>
    );
  },
);

const styles = StyleSheet.create({
  position: {
    position: "absolute",
    zIndex: 50,
  },
});

ActionPopupMenu.displayName = "ActionPopupMenu";
